import { render, staticRenderFns } from "./CAMFee.vue?vue&type=template&id=72ace9ca&"
import script from "./CAMFee.vue?vue&type=script&lang=js&"
export * from "./CAMFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports